import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import Layout from './components/Layout';
import A11yWidget from './components/A11yWidget';
import WhatsAppButton from './components/WhatsAppButton';
import ScrollToTop from './components/ScrollToTop';
import RouteProgress from './components/RouteProgress';
import { captureTracking } from './lib/tracking';
import Home from './pages/Home';
import Services from './pages/Services';
import Method from './pages/Method';
import About from './pages/About';
import Results from './pages/Results';
import Contact from './pages/Contact';
import Landing from './pages/Landing';
import Investors from './pages/Investors';
import Ceo from './pages/Ceo';
import Experts from './pages/Experts';
import Zchuta from './pages/Zchuta';
import AIManifest from './pages/AIManifest';
import Admin from './pages/Admin';
import AuthCallback from './pages/AuthCallback';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
//
// Top-level router — intercepts the Emergent OAuth redirect (which lands as
// `/admin#session_id=...`) BEFORE normal protected routes render. Per the
// playbook this check MUST run synchronously during render, not in useEffect,
// to avoid the race condition where Admin.jsx hits /auth/me before the
// session cookie is established.
const AppRouter = () => {
  const location = useLocation();
  if (location.hash && location.hash.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      {/* Standalone routes (no main Layout) — pitch decks / funnels with unique branding */}
      <Route path="/admin" element={<Admin />} />
      <Route path="/landing" element={<Landing />} />
      <Route path="/investors" element={<Investors />} />
      <Route path="/zchuta" element={<Zchuta />} />
      <Route path="/ai-manifest" element={<AIManifest />} />

      {/* Main site with Layout — includes the two new landings in the site menu */}
      <Route
        path="*"
        element={
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/method" element={<Method />} />
              <Route path="/experts" element={<Experts />} />
              <Route path="/ceo" element={<Ceo />} />
              <Route path="/about" element={<About />} />
              <Route path="/results" element={<Results />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </Layout>
        }
      />
    </Routes>
  );
};

function App() {
  // Capture marketing/visitor attribution ONCE per session (first-touch).
  // Idempotent — subsequent calls return the same snapshot from sessionStorage.
  if (typeof window !== 'undefined') {
    captureTracking();
  }

  return (
    <div className="App" dir="rtl">
      <BrowserRouter>
        {/* Bronze 2px progress bar — shows only on route transitions >300ms */}
        <RouteProgress />
        {/* Scroll to top on route change (skips POP + preserves #anchors) */}
        <ScrollToTop />
        <AppRouter />
        {/* Floating WhatsApp button — must be inside BrowserRouter to read pathname */}
        <WhatsAppButton />
      </BrowserRouter>
      <A11yWidget />
      <Toaster />
    </div>
  );
}

export default App;
